import React from 'react';
import { useSelector } from 'react-redux';
import BarChart from './BarChart';

const SectorChartCard = () => {
  const richLists = useSelector((state) => state.richLists);
  const { activeList } = richLists;

  return (
    <div className="flex flex-col flex-grow w-full bg-white rounded-md py-3 px-4 my-2">
      <h2 className="w-full mb-2 font-bold text-2xl text-yellow-600">
        {activeList === 'AFR2020'
          ? 'AFR'
          : activeList === 'Oz2020'
          ? 'The Australian'
          : 'Forbes'}{' '}
        Top 5 Industry Sectors
      </h2>
      <BarChart />
    </div>
  );
};

export default SectorChartCard;
